import Vue from 'vue'
import { Button, DatePicker, TimeSelect, Message, Input, Select, Option, Menu, Submenu, MenuItemGroup, MenuItem, Tabs, TabPane, Tree, Table, TableColumn, Pagination, Dropdown, DropdownMenu, DropdownItem, MessageBox, Drawer, Form, FormItem, Dialog, Loading, TimePicker, Tooltip, Upload, Checkbox, Radio, Divider, CheckboxGroup, Collapse, CollapseItem, Popover, RadioGroup, RadioButton, ColorPicker, InputNumber } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Button)
Vue.use(TimeSelect)
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tree)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Drawer)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Dialog)
Vue.use(Tooltip)
Vue.use(Loading.directive)
Vue.use(TimePicker)
Vue.use(Upload)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Divider)
Vue.use(CheckboxGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Popover)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(ColorPicker)
Vue.use(InputNumber)

let messageInstance = null
const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close()
  }
  messageInstance = Message(options)
}
['error', 'success', 'info', 'warning'].forEach(type => {
  resetMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    return resetMessage(options)
  }
})

Vue.prototype.$loading = Loading.service
Vue.prototype.$message = resetMessage
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
